import Fonts from '../../../../shared/assets/style/default/fonts';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const ChannelChoiceTitle = styled.p`
  color: white;
  font-size: ${32 * Screen.widthRatio}px;
  text-align: center;
  font-family: ${Fonts['regular']};
  line-height: ${40 * Screen.widthRatio}px;
`;

export default ChannelChoiceTitle;
